export default {
    // 分页获取材料列表
    aplianceList: "/material/getMaterialPage",
    // 根据id获取材料详情
    aplianceDetail: "/material/getMaterialDetail",
    // 新增材料
    aplianceAdd: "/material/saveMaterial",
    // 根据id批量删除材料
    aplianceDelete: "/material/delMaterial",
    // 根据id修改材料
    aplianceUpdate: "/material/updateMaterial",
    // 根据id修改材料状态
    aplianceUpdateStatus: "/material/updateMaterialStatus",
    // 获取商店列表
    aplianceStoreList: "/material/getStoreList",
};
